import { defineMessages } from "react-intl";

export const linkedRecordRowActionsText = defineMessages({
  unlinkTooltip: {
    defaultMessage: "Unlink record",
    id: "rlTe6o",
  },
});
